import styled, { css } from 'styled-components';

import { messageTokens } from '../../tokens/components/Message/tokens';
import { avatarTokens } from '../../tokens/components/Avatar/tokens';

import { AvatarIcon } from '../Avatar/styles';
import { FieldControl } from '../Field/styles';
import { StyledButton } from '../Button/Button';
import { TextAreaElement } from '../_common/CoreTextArea/CoreTextArea';
import ControllerWrapper from '../_common/Controller/components/ControllerWrapper/ControllerWrapper';

const messageRoles = {
  outbound: css`
    background: ${messageTokens.WrapperBackgroundColorInbound};
    border-color: ${messageTokens.WrapperBorderColorInbound};
  `,
  inbound: css`
    background: ${messageTokens.WrapperBackgroundColorOutbound};
    border-color: ${messageTokens.WrapperBorderColorOutbound};
  `,
};

/* @internal */
export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  max-width: 768px;
`;

/* @internal */
export const MessageInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${messageTokens.InfoSpacingHorizontal};

  ${AvatarIcon} {
    min-width: ${avatarTokens.SizeMessages};
    width: ${avatarTokens.SizeMessages};
    height: ${avatarTokens.SizeMessages};
  }
`;

/* @internal */
export const MessageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 45px;
`;

/* @internal */
export const MessageContentBubble = styled.div`
  border-radius: ${messageTokens.WrapperBorderRadiusDefault};
  border-style: ${messageTokens.WrapperBorderStyleDefault};
  border-top-left-radius: 0;
  border-width: ${messageTokens.WrapperBorderWidthDefault};
  display: flex;
  flex-direction: column;
  padding: ${messageTokens.WrapperSpacingHorizontal} ${messageTokens.WrapperSpacingVertical};
  width: fit-content;

  ${({ theme }) => messageRoles[theme.messageRole]};
`;

/* @internal */
export const MessageAttachments = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: ${messageTokens.AttachmentSpacingGapWrapper};
  margin-top: 16px;
`;

/* @internal */
export const MessageAttachmentWrapper = styled.div`
  align-items: center;
  background: ${messageTokens.AttachmentBackgroundColorDefault};
  border-color: ${messageTokens.AttachmentBorderColorDefault};
  border-radius: ${messageTokens.AttachmentBorderRadiusDefault};
  border-style: ${messageTokens.AttachmentBorderStyleDefault};
  border-width: ${messageTokens.AttachmentBorderWidthDefault};
  display: inline-flex;
  gap: ${messageTokens.AttachmentSpacingHorizontal};
  padding: ${messageTokens.AttachmentSpacingHorizontal} ${messageTokens.AttachmentSpacingVertical};
`;

/* @internal */
export const MessageMetadata = styled.div`
  color: ${messageTokens.InfoFontColorDefault};
  font-size: ${messageTokens.InfoFontSizeDefault};
`;

/* @internal */
export const MessageReplyWrapper = styled.div`
  max-width: 768px;
  padding-left: 45px;
  margin-top: 12px; // +24px from MessageWrapper = 32px

  ${FieldControl} {
    max-width: 100%;
  }

  ${ControllerWrapper}, ${TextAreaElement} {
    width: 100%;
  }
`;

/* @internal */
export const MessageReplyActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;

  ${StyledButton}:only-child {
    margin-left: auto;
  }
`;

/* @internal */
export const MessagePrompts = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

/* @internal */
export const MessageScrollWrapper = styled.div`
  overflow-y: auto;
  height: ${({ theme }) => theme.messageScrollerHeight};
  max-width: 768px;
`;
